import { render, staticRenderFns } from "./quoteDetail.vue?vue&type=template&id=2a8d04e0&scoped=true"
import script from "./quoteDetail.vue?vue&type=script&lang=js"
export * from "./quoteDetail.vue?vue&type=script&lang=js"
import style0 from "./quoteDetail.vue?vue&type=style&index=0&id=2a8d04e0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a8d04e0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\workspace\\ysorder\\order_admin_client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a8d04e0')) {
      api.createRecord('2a8d04e0', component.options)
    } else {
      api.reload('2a8d04e0', component.options)
    }
    module.hot.accept("./quoteDetail.vue?vue&type=template&id=2a8d04e0&scoped=true", function () {
      api.rerender('2a8d04e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/order/inquiry/quoteDetail.vue"
export default component.exports